<footer class="bg-primary footer">
    <div fxLayout="column" fxLayout.gt-sm="row wrap" fxLayoutAlign="center center" class="border-bottom-mute subscribe-block theme-container">
        <div fxFlex="100" fxFlex.gt-sm="40" fxLayout="column" fxLayoutAlign="center center"> 
            <h1 class="fw-500">Подпишитесь на нашу Рассылку</h1>
            <h3 class="fw-300 secondary-color">Будьте в курсе наших самых свежих новостей и новинок</h3>
        </div>
        <form method="get" class="subscribe-search-form" fxLayout="row" fxFlex="100" fxFlex.gt-sm="42.4" ngClass.sm="mt-2" ngClass.xs="mt-2">
            <input type="email" id="subscribeEmailText" placeholder=" Ваш email..." fxFlex>
            <button mat-raised-button color="accent" (click)="subscribeToNews()" type="button" class="mat-elevation-z0 text-muted">Подписаться</button>
        </form>
    </div>
    <div fxLayout="row wrap" fxLayoutAlign="space-between" class="py-3 border-bottom-mute theme-container">
      <div fxFlex="100" fxFlex.gt-sm="20" fxFlex.sm="40">
        <h3 class="col-title">ПОЛЕЗНЫЕ ССЫЛКИ</h3>
        <p class="mt-1"><a routerLink="/cart" class="link secondary-color">Корзина</a></p>
        <p class="mt-1"><a routerLink="/about-us" class="link secondary-color">О магазине</a></p>
        <p class="mt-1"><a routerLink="/news" class="link secondary-color">Новости</a></p>
        <p class="mt-1"><a routerLink="/contact" class="link secondary-color">Контакты</a></p>
      </div>
      <div fxFlex="100" fxFlex.gt-sm="30" fxFlex.sm="60" ngClass.xs="mt-2" class="contact-information">
        <h3 class="col-title">КОНТАКТНАЯ ИНФОРМАЦИЯ</h3>
        <p fxLayout="row" fxLayoutAlign="start center" class="mt-2 secondary-color">
          <mat-icon>location_on</mat-icon>
          <span>Краснодар, Россия</span>
        </p>
        <p fxLayout="row" fxLayoutAlign="start center" class="mt-1 secondary-color">
          <mat-icon>call</mat-icon>
          <span>+7 (918) 011-53-53</span>
        </p>
        <p fxLayout="row" fxLayoutAlign="start center" class="mt-1 secondary-color">
          <mat-icon>mail_outline</mat-icon>
          <span>thaicos.sup@gmail.com</span>
        </p>
        <p fxLayout="row" fxLayoutAlign="start center" class="mt-1 secondary-color">
          <mat-icon>schedule</mat-icon>
          <span>Пн - Суб / 9:00 - 20:00</span>
        </p>
      </div>
      <div fxFlex="100" fxFlex.gt-sm="20" fxFlex.sm="60" ngClass.xs="mt-2">
        <h3 class="col-title">СКАЧАЙТЕ НАШЕ ПРИЛОЖЕНИЕ</h3>
          <a class="logo" href="https://apps.apple.com/ru/app/thaicos/id1383219094"><img src="assets/images/appStore.png" class="appSotreIcon mt-2"></a>
          <a class="logo" href="https://play.google.com/store/apps/details?id=com.kg.thaicos&hl=ru"><img src="assets/images/googleMarket.png" class="appSotreIcon"></a>
      </div>
      <div fxFlex="100" fxFlex.gt-sm="30" ngClass.sm="mt-2" ngClass.xs="mt-2">
      </div>
    </div>
    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center" class="copyright secondary-color theme-container">
        <p ngClass.xs="mt-1">Copyright © 2020 All Rights Reserved</p>
        <p>Designed & Developed by <a mat-button href="http://themeseason.com/" target="_blank">ThemeSeason</a></p>
    </div>
</footer>
